import { UtpCardStructure } from 'common/components';
import { INTERIOR_DOORS_CDN_PATH } from '../../interior-doors-constants';
import { Assortment, FreeMeasurement, QualityAssurance, Services } from './components';

export const INTERIOR_DOORS_UTP_CARD_LIST: UtpCardStructure<{
  onConsultationSignupBtnClick: () => void;
}>[] = [
  {
    elementName: 'Консультация и запись на замер',
    header: {
      title: 'Консультация и\u00A0запись на\u00A0замер',
      mobileTitle: 'Консультация и\u00A0замер',
    },
    description: {
      text: 'Специалист проконсультирует и\u00A0подготовит расчёт',
      mobileText: 'Проконсультируем и\u00A0подготовим расчёт',
    },
    image: {
      alt: 'Консультация и запись на замер',
      src: `${INTERIOR_DOORS_CDN_PATH}/utp/free-measurement.png/free-measurement-01.png`,
    },
    modal: { content: FreeMeasurement },
  },
  {
    elementName: 'Широкий ассортимент ',
    header: {
      title: 'Широкий ассортимент ',
    },
    description: {
      text: 'Множество цветов, дизайнов и\u00A0материалов',
    },
    image: {
      alt: 'Широкий ассортимент ',
      src: `${INTERIOR_DOORS_CDN_PATH}/utp/assortment.png/assortment.png`,
    },
    modal: { content: Assortment },
  },
  {
    elementName: 'Услуги Лемана ПРО',
    header: {
      title: 'Услуги Лемана\u00A0ПРО',
    },
    description: {
      text: 'Все работы под ключ: от\u00A0замера до\u00A0установки',
    },
    image: {
      alt: 'Услуги Лемана ПРО',
      src: `${INTERIOR_DOORS_CDN_PATH}/utp/services.png/services-01.png`,
    },
    modal: { content: Services },
  },
  {
    elementName: 'Гарантия качества',
    header: {
      title: 'Гарантия качества',
      mobileTitle: 'Гарантия',
    },
    description: {
      text: '1\u00A0год гарантии на\u00A0установку, а\u00A0с\u00A0Сервисной картой\u00A0\u2014 2\u00A0года',
    },
    image: {
      alt: 'Гарантия качества',
      src: `${INTERIOR_DOORS_CDN_PATH}/utp/quality-assurance.png/quality-assurance-01.png`,
    },
    modal: { content: QualityAssurance },
  },
];
